document.addEventListener('DOMContentLoaded', function () {
	// najdeme na stránce všechny podřízené selectboxy
	document.querySelectorAll('select[data-depends]').forEach((childSelect) => {
		console.log(childSelect.dataset.depends);
		//split childSelect.dataset.depends into array by comma
		let dependNames = childSelect.dataset.depends.split(',');
		let dependUrlParams = childSelect.dataset.urlParams ? childSelect.dataset.urlParams.split(',') : [];
		console.log(dependNames);
		//foraech parentSelects
		dependNames.forEach((dependName, key) => {
			let parentSelect = childSelect.form[dependName]; // nadřízený <select>
			let url = childSelect.dataset.url; // atribut data-url
			let items = JSON.parse(childSelect.dataset.items || 'null'); // atribut data-items

			// když uživatel změní vybranou položku v nadřízeném selectu...
			parentSelect.addEventListener('change', () => {
				// pokud existuje atribut data-items...
				if (items) {
					// nahrajeme rovnou do podřízeného selectboxu nové položky
					updateSelectbox(childSelect, items[parentSelect.value]);
				}

				// pokud existuje atribut data-url...
				if (url) {
					let finalUrl = url + '&changed=' + dependName;
					dependNames.forEach((dependName, key) => {
						let parentSelect = childSelect.form[dependName]; // nadřízený <select>
						if(dependUrlParams[key]) {
							finalUrl = finalUrl + '&' + encodeURIComponent(dependUrlParams[key]) + '=' + encodeURIComponent(parentSelect.value);
						} else {
							finalUrl = finalUrl.replace(encodeURIComponent('#'), encodeURIComponent(parentSelect.value));
						}
					});

					// uděláme AJAXový požadavek na endpoint s vybranou položkou místo placeholderu
					fetch(finalUrl)
						.then((response) => response.json())
						// a nahrajeme do podřízeného selectboxu nové položky
						.then((data) => updateSelectbox(childSelect, data));
				}
			});
		});

	});
});
// přepíše <options> v <select>
function updateSelectbox(select, items)
{
	select.innerHTML = ''; // odstraníme vše
	for (let id in items) { // vložíme nové
		let el = document.createElement('option');
		el.setAttribute('value', id);
		el.innerText = items[id];
		select.appendChild(el);
	}

	const dependedFilledEvent = new CustomEvent('dependedFilled', {
		detail: { items: items},
	});

	select.dispatchEvent(dependedFilledEvent);
}